import React from "react";
import { Col, Space } from "antd";
import NoticeList from "../../components/NoticeList";

function NoticeManagement() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">공지/이벤트 관리</h3>
                <NoticeList />
            </Space>
        </div>
    );
}

export default NoticeManagement;
